import React, { FC } from 'react'

import Tags, { TagsProps } from '../Tags'
import NonCollapsable, { NonCollapsableProps } from '../NonCollapsable'

export type RecipeTagsSectionProps = {
  className?: string
  nonCollapsableProps?: NonCollapsableProps
  tagsProps?: TagsProps
}

const RecipeTagsSection: FC<RecipeTagsSectionProps> = (props) => {
  const { className, tagsProps, nonCollapsableProps } = props

  return (
    <NonCollapsable className={className} {...nonCollapsableProps}>
      <Tags {...tagsProps} />
    </NonCollapsable>
  )
}

export default RecipeTagsSection
